// extracted by mini-css-extract-plugin
export default {"container":"_01_MissionInfo_container__A0ifJ"};